<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <Popover class="relative bg-white">
        <div class=" flex justify-between items-center px-4 py-6 sm:px-6 md:justify-start md:space-x-10 ">
            <div>
                <a href="/" class="flex">
                    <h1 class="text-2xl">
                        Matthias Kunkler
                    </h1>
                </a>
            </div>
            <div class="-mr-2 -my-2 md:hidden">
                <PopoverButton class=" bg-white rounded-md p-2 inline-flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 ">
                    <span class="sr-only">
                        Open menu
                    </span>
                    <Bars3Icon class="h-6 w-6" aria-hidden="true" />
                </PopoverButton>
            </div>
            <div class="hidden md:flex-1 md:flex md:items-center md:justify-between">
                <PopoverGroup as="nav" class="flex space-x-10">
                  <!-- Dropdown: Ausstellungen -->
                  <Popover v-slot="{ open }" class="relative">
                    <PopoverButton
                      :class="[
                        'group bg-white rounded-md inline-flex items-center text-lg font-medium focus:outline-none'
                      ]"
                    >
                      <span
                        :class="[
                          currentPath.startsWith('/ausstellung')
                            ? 'font-medium !text-red-800 underline underline-offset-8'
                            : 'text-gray-500 group-hover:text-gray-900'
                        ]"
                      >
                        Ausstellungen
                      </span>
                      <ChevronDownIcon
                        :class="[
                          currentPath.startsWith('/ausstellung')
                            ? '!text-red-800'
                            : 'text-gray-400',
                          'ml-2 h-5 w-5 group-hover:text-gray-500'
                        ]"
                        aria-hidden="true"
                      />
                    </PopoverButton>

                
                    <transition
                      enter-active-class="transition ease-out duration-200"
                      enter-from-class="opacity-0 translate-y-1"
                      enter-to-class="opacity-100 translate-y-0"
                      leave-active-class="transition ease-in duration-150"
                      leave-from-class="opacity-100 translate-y-0"
                      leave-to-class="opacity-0 translate-y-1"
                    >
                      <PopoverPanel class="absolute z-20 mt-3 w-screen max-w-md lg:max-w-3xl">
                        <div class="rounded-lg shadow-lg overflow-hidden bg-white">
                          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 p-6">
                            <a
                              v-for="item in sortedArray"
                              :key="item.id"
                              :href="item.url"
                              class="flex items-center gap-4 p-3 hover:bg-gray-100 rounded-md transition"
                            >
                              <img
                                v-if="item.img"
                                :src="item.img"
                                class="w-12 h-12 object-cover rounded"
                              />
                              <div>
                                <span class="font-medium text-gray-900">
                                  {{ item.topLine }}
                                </span>
                                <br />
                                <span class="text-sm text-gray-600">
                                  {{ item.bottomLine }}
                                </span>
                              </div>
                            </a>
                          </div>
                        </div>
                      </PopoverPanel>
                    </transition>
                  </Popover>
                
                  <!-- Dropdown: Texte -->
                  <Popover v-slot="{ open }" class="relative">
                    <PopoverButton
                      :class="[
                        'group bg-white rounded-md inline-flex items-center text-lg font-medium focus:outline-none focus:ring-offset-2'
                      ]"
                    >
                      <span
                        :class="[
                          currentPath.startsWith('/text')
                            ? 'font-medium !text-red-800 underline underline-offset-8'
                            : 'text-gray-500 group-hover:text-gray-900'
                        ]"
                      >
                        Texte
                      </span>
                      <ChevronDownIcon
                        :class="[
                          currentPath.startsWith('/text')
                            ? '!text-red-800'
                            : 'text-gray-400',
                          'ml-2 h-5 w-5 group-hover:text-gray-500'
                        ]"
                        aria-hidden="true"
                      />
                    </PopoverButton>
                  
                    <transition
                      enter-active-class="transition ease-out duration-200"
                      enter-from-class="opacity-0 translate-y-1"
                      enter-to-class="opacity-100 translate-y-0"
                      leave-active-class="transition ease-in duration-150"
                      leave-from-class="opacity-100 translate-y-0"
                      leave-to-class="opacity-0 translate-y-1"
                    >
                      <PopoverPanel class="absolute z-20 left-1/2 transform -translate-x-1/2 mt-3 px-2 w-screen max-w-xs sm:px-0">
                        <div class="rounded-lg shadow-lg overflow-hidden bg-white">
                          <div class="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8">
                            <a
                              v-for="item in (copy.kunklertexte || [])"
                              :key="item.id"
                              :href="item.url"
                              class="text-base font-medium text-gray-900 hover:bg-gray-100 block px-3 py-2 rounded-md"
                            >
                              {{ item.title }}
                            </a>
                          </div>
                        </div>
                      </PopoverPanel>
                    </transition>
                  </Popover>

                
                  <!-- Statische Seitenlinks -->
                  <template v-for="link in staticLinks" :key="link.url">
                    <a
                      :href="link.url"
                      :class="[
                        'text-lg transition-colors duration-150',
                        currentPath === link.url
                          ? 'font-medium !text-red-800 underline underline-offset-8'
                          : 'text-gray-500 hover:text-red-500'
                      ]"
                    >
                      {{ link.label }}
                    </a>
                  </template>
                </PopoverGroup>

            </div>
        </div>
        
        
        <transition enter-active-class="duration-200 ease-out" enter-from-class="opacity-0 scale-95" enter-to-class="opacity-100 scale-100" leave-active-class="duration-100 ease-in" leave-from-class="opacity-100 scale-100" leave-to-class="opacity-0 scale-95">
            <PopoverPanel focus class=" z-20 absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden ">
                <div class=" rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50 ">
                    <div class="pt-5 pb-6 px-5">
                        <div class="flex items-center justify-between">
                            <div>
                                Matthias Kunkler
                            </div>
                            <div class="-mr-2">
                                <PopoverButton class=" bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none ">
                                    <span class="sr-only">
                                        Close menu
                                    </span>
                                    <XMarkIcon class="h-6 w-6" aria-hidden="true" />
                                </PopoverButton>
                            </div>
                        </div>
                        <div class="mt-6">
                            <nav class="grid gap-6">
                                <a v-for="item in sortedArray" :key="item.sortierfeld" :href="item.url" class="-m-3 p-3 flex items-center rounded-lg hover:bg-gray-50">
                                    <div class="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-md bg-gray-200 text-black overflow-hidden">
                                        <img v-if="item.img" :src="item.img" alt="" class="object-cover h-full w-full rounded" />
                                    </div>
                                    <div class="ml-4 text-sm font-medium text-gray-900 leading-tight">
                                        <span>
                                            {{ item.topLine }}
                                        </span>
                                        <br />
                                        <span class="text-gray-600">
                                            {{ item.bottomLine }}
                                        </span>
                                    </div>
                                </a>
                            </nav>
                        </div>
                    </div>
                    <div class="py-6 px-5">
                        <div class="grid grid-cols-2 gap-4 mb-4 bg-gray-50">
                            <a
                              v-for="item in (copy.kunklertexte || []).slice().reverse()"
                              :key="item.id"
                              :href="item.url"
                              class="text-base font-medium text-gray-900 hover:bg-gray-100"
                            >
                              {{ item.title }}
                            </a>
                        </div>
                        <div class="grid grid-cols-2 gap-4">
                            <a href="/vita" class="text-base font-medium text-gray-900 hover:text-gray-700">
                                Vita
                            </a>
                            <a href="/sammlungen" class="text-base font-medium text-gray-900 hover:text-gray-700">
                                Sammlungen
                            </a>
                            <a href="/publikationen" class="text-base font-medium text-gray-900 hover:text-gray-700">
                                Publikationen
                            </a>
                            <a href="/ueber-diese-website" class="text-base font-medium text-gray-900 hover:text-gray-700">
                                Über diese Website
                            </a>
                        </div>
                    </div>
                </div>
            </PopoverPanel>
        </transition>
    </Popover>
</template>

<script>
import { Popover, PopoverButton, PopoverGroup, PopoverPanel, } from "@headlessui/vue";
import { Bars3Icon, XMarkIcon, ChevronDownIcon, } from "@heroicons/vue/24/solid";
import axios from "axios";

export default {
    components: { Popover, PopoverButton, PopoverGroup, PopoverPanel, Bars3Icon, XMarkIcon, ChevronDownIcon, },

    data() {
      return {
        info: [],
        copy: {},
        currentPath: window.location.pathname.replace(/\/$/, ''), // z. B. "/vita/" → "/vita"
        staticLinks: [
          { label: "Vita", url: "/vita" },
          { label: "Sammlungen", url: "/sammlungen" },
          { label: "Publikationen", url: "/publikationen" },
          { label: "Über diese Website", url: "/ueber-diese-website" },
        ],
      };
    },

    computed: {
      sortedArray() {
        return (this.info || [])
          .slice()
          .sort((a, b) => a.sortierfeld - b.sortierfeld)
          .map((item) => {
            const parts = item.title.split(",");
            const topLine =
              parts.length > 1 ? parts.slice(0, -1).join(",").trim() : item.title;
            const bottomLine = parts.length > 1 ? parts[parts.length - 1].trim() : "";
    
            return {
              ...item,
              topLine,
              bottomLine,
            };
          });
      },
    },


    mounted() {
        axios.get("/ausstellungen.json").then((response) => {
            this.info = response.data.kunklerausstellungen;
            console.log("Ausstellungen geladen:", this.info);
          });

        axios.get("/texte.json").then((response) => { this.copy = response.data; });
        
        this.currentPath = window.location.pathname.replace(/\/$/, '');
          console.log('Aktueller Pfad:', this.currentPath);

    },
}; 
</script>